import { createFileRoute } from '@tanstack/react-router';
import { TenantComplianceTab } from '@/components/tenants/TenantComplianceTab';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/compliance')({
  component: ComplianceRoute,
});

function ComplianceRoute() {
  const { tenantCode } = Route.useParams();

  return (
    <div className="space-y-4">
      <TenantComplianceTab tenantCode={tenantCode} />
    </div>
  );
}
